(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tabs-collection"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initTabAutoChange(section) {
    if (section.dataset.tabAutoInit === '1') return;
    section.dataset.tabAutoInit = '1';

    var tabsUl = section.querySelector('.t4s-tabs-ul');
    if (!tabsUl) return;

    var lastTriggered = -1;
    var debounceTimer = null;

    function syncTab() {
      if (window.innerWidth >= 992) return;
      var items = tabsUl.querySelectorAll('.t4s-tab-item');
      var selectedIdx = -1;
      for (var i = 0; i < items.length; i++) {
        if (items[i].classList.contains('is-selected')) {
          selectedIdx = i;
          break;
        }
      }
      if (selectedIdx >= 0 && selectedIdx !== lastTriggered) {
        lastTriggered = selectedIdx;
        var link = items[selectedIdx].querySelector('a[data-t4s-tab-item]');
        if (link && !link.classList.contains('t4s-active')) {
          link.click();
        }
      }
    }

    function scheduleSync() {
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(syncTab, 80);
    }

    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var target = mutations[i].target;
        if (target.classList && target.classList.contains('t4s-tab-item')) {
          scheduleSync();
          return;
        }
      }
    });

    observer.observe(tabsUl, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true
    });

    window.addEventListener('resize', function() {
      if (window.innerWidth >= 992) {
        lastTriggered = -1;
      } else {
        scheduleSync();
      }
    });
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = scope.querySelectorAll('[data-auto-change-mobile="true"]');
    for (var i = 0; i < sections.length; i++) {
      initTabAutoChange(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(e) {
    initAll(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
